import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');
    try {
      const res = await axios.post('https://api.safenetbanking.com/api/forgot-password', { email });
      if (res.data.success) {
        setMessage('If your email exists, a reset link will be sent.');
      } else {
        setError(res.data.error || 'Failed to send reset email');
      }
    } catch (err) {
      setError('Failed to send reset email: ' + (err.response?.data?.error || err.message));
    }
    setLoading(false);
  };

  return (
    <main className="auth-page forgot-password-page">
      <div className="auth-navbar"><a className="logo" href="/"><img src="/logo.jpg" alt="company logo" /></a>
        <div className="desktop-alternative">
          <p>Remembered your password?</p>
          <button className="transparent" onClick={() => navigate('/login')}>Login Here</button>
        </div>
      </div>
      <div className="form-container">
        <form onSubmit={handleSubmit}>
          <div className="mobile-alternative">
            <p>Remembered your password?</p>
            <button className="transparent" type="button" onClick={() => navigate('/login')}>Login Here</button>
          </div>
          <div className="header">
            <h4>Forgot your password?</h4>
            <h3>Reset Password</h3>
          </div>
          {error && <h2 className="text-danger">{error}</h2>}
          {message && <h2 className="text-success">{message}</h2>}
          <div className="form-control"><label>Email</label><input type="email" required placeholder="Enter your email" value={email} onChange={e => setEmail(e.target.value)} /></div>
          <div className="submit-btn"><button className="blue long" type="submit" disabled={loading}>{loading ? 'Sending...' : 'Send Reset Link'}</button></div>
        </form>
        <div className="img"><img src="forget-password.jpg" alt="reset password" /></div>
      </div>
    </main>
  );
}
